/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export * from './MobileConfirmationDialog.component';
